exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".countries{overflow-y:auto;position:relative;background:var(--white);color:var(--black);padding:20px;width:calc(100% - 40px);margin-bottom:var(--padding-bottom);margin-top:var(--margin-top)}.countries__list{padding-bottom:var(--padding-bottom)}.countries__title{margin:0;margin-bottom:10px}.countries__section{display:flex;flex-direction:column;margin-bottom:10px}.countries__section__title{margin:0;color:var(--black);font-size:var(--font-large)}.countries__section__button{background:none;border:none;font-size:var(--font-medium);text-align:left;padding:10px 0}", ""]);

// exports
